<template>
  <div id="pageAplicacion">
    <div>
      <v-container grid-list-xl fluid>
        <div v-if="showAlert == true">
          <alert-empty></alert-empty>
        </div>
        <v-layout justify-center>
          <v-flex lg12>
            <v-container>
              <v-layout>
                <v-flex xs12 md4>
                  <!-- FECHA-->
                  <v-menu
                    v-model="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="fechaEvolucion"
                        label="Fecha"
                        prepend-icon="event"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="fechaEvolucion"
                      no-title
                      @input="menu1 = false"
                      locale="es"
                      first-day-of-week="1"
                    >
                    </v-date-picker>
                  </v-menu>
                  <!-- FECHA APROBACION -->
                </v-flex>
                <v-flex xs12 md4>
                  <v-select
                    v-model="nivelValue"
                    :items="nivelSelect"
                    item-value="description"
                    item-text="description"
                    label="Nivel"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-select
                    v-model="tipoMaterialValue"
                    :items="tipoMaterialSelect"
                    item-value="description"
                    item-text="description"
                    label="Tipo Material"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-select
                    v-model="tipoPruebaValue"
                    :items="tipoPruebaSelect"
                    item-value="description"
                    item-text="description"
                    label="Tipo Prueba"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-select
                    v-model="tipoDocumentoValue"
                    :items="tipoDocumentoSelect"
                    item-value="description"
                    item-text="description"
                    label="Tipo Documento"
                  ></v-select>
                </v-flex>
                <v-btn
                  fab
                  dark
                  color="teal"
                  title="Filtrar evolucion"
                  @click="filter()"
                >
                  <v-icon dark>filter_list</v-icon>
                </v-btn>
                <v-btn
                  fab
                  dark
                  color="red darken-4"
                  title="Limpiar filtros"
                  @click="clear()"
                >
                  <v-icon dark>clear_all</v-icon>
                </v-btn>
              </v-layout>
              <v-layout>
                <v-flex xs12 md8></v-flex>
                <v-flex>
                  <v-btn
                    v-if="botonHidden != true"
                    disabled
                    color="primary"
                    class="mb-2"
                    @click.prevent="downloadCsv()"
                  >
                    Descargar Detalle
                    <v-icon right dark>save</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex>
                  <v-btn
                    v-if="btnHidden != true"
                    color="primary"
                    dark
                    class="mb-2"
                    @click.prevent="downloadCsv()"
                  >
                    Descargar Detalle
                    <v-icon right dark>save</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex>
                  <v-btn
                    v-if="botonHidden != true"
                    disabled
                    color="primary"
                    class="mb-2"
                    @click.prevent="downloadExcel()"
                  >
                    Exportar Excel
                    <v-icon right dark>save</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="btnHidden != true"
                    color="primary"
                    dark
                    class="mb-2"
                    @click.prevent="downloadExcel()"
                  >
                    Exportar Excel
                    <v-icon right dark>save</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-else>
            <v-widget
              :key="indexChart"
              v-if="dataReady == true"
              title="Evolución Progreso"
              content-bg="white"
            >
              <div slot="widget-content">
                <e-chart
                  :path-option="[
                    ['dataset.source', res],
                    ['color', [color.lightBlue.base, color.pink.base]],
                    ['legend.show', true],
                    ['xAxis.axisLabel.show', true],
                    ['yAxis.axisLabel.show', true],
                    ['grid.left', '2%'],
                    ['grid.bottom', '5%'],
                    ['grid.right', '3%'],
                    ['series[0].type', 'bar'],
                    ['series[0].areaStyle', {}],
                    ['series[0].smooth', true],
                    ['series[1].type', 'bar'],
                    ['series[1].areaStyle', {}],
                    ['series[1].smooth', true],
                  ]"
                  height="400px"
                  width="100%"
                ></e-chart>
              </div>
            </v-widget>
          </div>
        </v-flex>
      </v-layout>
      <v-dialog v-model="dialogLoading" persistent max-width="390">
        <loading-descarga></loading-descarga>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import API from "@/api";
import EChart from "@/components/chart/echart";
import VWidget from "@/components/VWidget";
import Material from "vuetify/es5/util/colors";
import CircleStatistic from "@/components/widgets/statistic/CircleStatistic";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import { mapState } from "vuex";
import { misMixins } from "@/mixins/myMixing.js";

export default {
  components: {
    VWidget,
    EChart,
    CircleStatistic,
    Loading,
    LoadingDescarga,
    AlertEmpty,
  },
  mixins: [misMixins],
  data: () => ({
    color: Material,
    dialogLoading: false,
    contratoId: "",
    selectedTab: "tab-1",
    pruebas: [],
    fechaEvolucion: "",
    nivelSelect: "",
    nivelValue: "",
    tipoDocumentoValue: "",
    tipoDocumentoSelect: "",
    tipoMaterialValue: "",
    tipoMaterialSelect: "",
    tipoPruebaValue: "",
    tipoPruebaSelect: "",
    areaValue: "",
    areaSelect: "",
    menu1: false,
    dataReady: false,
    res: [],
    indexChart: 0,
    showAlert: false,
    btnHidden: true,
    botonHidden: false,
    loading: false,
    indeterminate: false,
    subProceso: "",
    nombreArchivo: "",
  }),
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 4000);
    },
  },
  computed: {},
  created() {
    this.contratoId = this.$store.getters.contratoStored;
    this.subProceso = this.$store.getters.subProTabSelectedStored;
    this.loadSelects();
  },
  mounted() {},
  methods: {
    downloadCsv() {
      this.dialogLoading = true;
      this.nombreDescargaCSV();
      this.downloadDetail();
    },
    downloadExcel() {
      this.dialogLoading = true;
      this.nombreDescargaExcel();
      this.downloadDetailExcel();
    },

    async loadSelects() {
      this.tipoMaterialSelect = await this.loadTipoMaterial();
      this.tipoPruebaSelect = await this.loadTipoPrueba();
      this.nivelSelect = await this.loadNivel();
      this.tipoDocumentoSelect = await this.loadTipoDocumento();
      if (
        this.tipoMaterialSelect.length > 0 &&
        this.tipoPruebaSelect.length > 0 &&
        this.nivelSelect.length > 0
      ) {
        this.showAlert = false;
      } else {
        this.showAlert = true;
      }
      //Con esto buscamos todos los valores y hacemos que printe en los filtros i en pantalla el ultimo
      this.pruebas = [];
      this.pruebas = await this.getUltimaFecha();
      if (this.pruebas.length > 0) {
        this.showAlert = false;
        this.tipoMaterialValue =
          this.pruebas[this.pruebas.length - 1].tipoMaterial;
        this.nivelValue = this.pruebas[this.pruebas.length - 1].nivel;
        this.fechaEvolucion = this.formatoFecha(
          this.pruebas[this.pruebas.length - 1].fechaProgreso
        );
      } else {
        this.showAlert = true;
      }
      this.loadData();
    },
    fechaAnterior() {
      let fechaHoy = new Date();
      let fechaAyer = fechaHoy.setDate(fechaHoy.getDate() - 1);
      let formatoAyer = new Date(fechaAyer).toISOString().substr(0, 10);
      this.fechaEvolucion = formatoAyer;
    },
    async getUltimaFecha() {
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idUserLogged = this.$store.getters.userLogged.id;
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        // contratoId:this.contratoId,
        // idUserLogged: idUserLogged,
        subProceso: subProceso,
        idContrato: idContrato,
        nivel: null,
        tipoMaterial: null,
        tipoDocumento: null,
        tipoPrueba: null,
        fecha_progreso: null,
      };
      return await axios
        .post("/evolucionFilter", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    async loadNivel() {
      return await axios
        .get("/evolucionNivel/" + this.contratoId + "/" + this.subProceso)
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          if (error.response.status === 400) {
            window.getApp.$emit(
              "ERROR_EXCEPTION2",
              error.response.data.message
            );
          } else {
            console.log(error);
            return [];
          }
        });
    },
    async loadTipoMaterial() {
      return await axios
        .get(
          "/evolucionTipoMaterial/" + this.contratoId + "/" + this.subProceso
        )
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    async loadTipoPrueba() {
      return await axios
        .get("/evolucionTipoPrueba/" + this.contratoId + "/" + this.subProceso)
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    async loadTipoDocumento() {
      return await axios
        .get(
          "/evolucionTipoDocumento/" + this.contratoId + "/" + this.subProceso
        )
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    clear() {
      this.tipoPruebaValue = "";
      this.tipoDocumentoValue = "";
      this.fechaEvolucion = "";
      this.nivelValue = "";
      this.tipoMaterialValue = "";
    },
    filter() {
      this.loadData();
    },
    async loadData() {
      this.loading = true;
      //dibujar la grafica
      this.pruebas = [];
      this.pruebas = await this.loadFilter();
      if (this.pruebas.length > 0) {
        this.showAlert = false;
        this.chartData();
      } else {
        this.showAlert = true;
      }
      this.dataReady = true;
      this.btnHidden = false;
      this.botonHidden = true;
      this.loading = false;
    },
    chartData() {
      let data = [];
      this.pruebas.forEach((m) => {
        data.push({
          tipoPrueba: m.tipoPrueba + "-" + m.subItemId.tipoDocumento,
          Cantidad: m.cantidadDia,
          Objetivo: m.cantidadDiaObj,
        });
      });
      this.res = data;
      this.indexChart += 1;
    },
    async loadFilter() {
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idUserLogged = this.$store.getters.userLogged.id;
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        // contratoId:this.contratoId,
        // idUserLogged: idUserLogged,
        subProceso: subProceso,
        idContrato: idContrato,
        nivel:
          this.nivelValue != "" && this.nivelValue != null
            ? this.nivelValue.description
            : null,
        tipoMaterial:
          this.tipoMaterialValue != "" && this.tipoMaterialValue != null
            ? this.tipoMaterialValue.description
            : null,
        tipoDocumento:
          this.tipoDocumentoValue != "" && this.tipoDocumentoValue != null
            ? this.tipoDocumentoValue
            : null,
        tipoPrueba:
          this.tipoPruebaValue != "" && this.tipoPruebaValue != null
            ? this.tipoPruebaValue
            : null,
        fecha_progreso:
          this.fechaEvolucion != "" && this.fechaEvolucion != null
            ? this.fechaEvolucion
            : null,
      };

      return await axios
        .post("/evolucionFilter", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    formatoFecha(f) {
      // Convierte un texto de la forma europea a la forma americana
      return f.replace(/^(\d{2})-(\d{2})-(\d{4})$/g, "$3-$2-$1");
    },
    nombreDescargaCSV() {
      // new Date(fechaAyer).toISOString().substr(0, 10)
      let fechaHoy = new Date().toISOString().substr(0, 10);
      // let horaHoy = new Hour()
      // let minHoy = new Minutes
      this.nombreArchivo =
        "DescargaEvolucionProgresoDiario" + fechaHoy + ".csv";
    },
    nombreDescargaExcel() {
      // new Date(fechaAyer).toISOString().substr(0, 10)
      let fechaHoy = new Date().toISOString().substr(0, 10);
      //let horaHoy = new Hour()
      //let minHoy = new Minutes
      this.nombreArchivo =
        "DescargaEvolucionProgresoDiario" + fechaHoy + ".xlsx";
    },

    downloadDetail() {
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idUserLogged = this.$store.getters.userLogged.id;
      let idContrato = this.$store.getters.contratoStored;
      let nombre = this.nombreArchivo;

      this.body = {
        // idUserLogged: idUserLogged,
        subProceso: subProceso,
        idContrato: idContrato,
        area: null,
        tipoDocumento:
          this.tipoDocumentoValue && this.tipoDocumentoValue != null
            ? this.tipoDocumentoValue
            : null,
        nivel:
          this.nivelValue && this.nivelValue != null
            ? this.nivelValue.description
            : null,
        tipoMaterial:
          this.tipomaterialValue && this.tipomaterialValue != null
            ? this.tipomaterialValue.description
            : null,
        tipoPrueba:
          this.tipoPruebaValue != "" && this.tipoPruebaValue != null
            ? this.tipoPruebaValue
            : null,
        fechaProgreso:
          this.fechaEvolucion != "" && this.fechaEvolucion != null
            ? this.fechaEvolucion
            : null,
      };
      axios
        .post("/evolucionFilter/downloadCsvPD", this.body, {
          responseType: "blob",
        })
        .then((response) => {
          //DESCARGA DE CSV
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", nombre); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch(function (error) {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
        });
    },
    downloadDetailExcel() {
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idUserLogged = this.$store.getters.userLogged.id;
      let idContrato = this.$store.getters.contratoStored;
      let nombre = this.nombreArchivo;

      this.body = {
        // idUserLogged: idUserLogged,
        subProceso: subProceso,
        idContrato: idContrato,
        area: null,
        tipoDocumento:
          this.tipoDocumentoValue && this.tipoDocumentoValue != null
            ? this.tipoDocumentoValue
            : null,
        nivel:
          this.nivelValue && this.nivelValue != null
            ? this.nivelValue.description
            : null,
        tipoMaterial:
          this.tipomaterialValue && this.tipomaterialValue != null
            ? this.tipomaterialValue.description
            : null,
        tipoPrueba:
          this.tipoPruebaValue != "" && this.tipoPruebaValue != null
            ? this.tipoPruebaValue
            : null,
        fechaProgreso:
          this.fechaEvolucion != "" && this.fechaEvolucion != null
            ? this.fechaEvolucion
            : null,
      };
      axios
        .post("/evolucionFilter/downloadExcelPD", this.body, {
          responseType: "blob",
        })
        .then((response) => {
          //DESCARGA DE excel
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", nombre); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch(function (error) {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
        });
    },
  },
};
</script>
